<template>
  <section class="userWx">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="cancelSubmit"
    >
      <div class="userWx-content">
        111
      </div>
      <div slot="footer" class="userWx-foot">
        <el-button @click="cancelSubmit">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "comUserWx",
  components: {},
  props: {
    value: Boolean,
    id: Number,
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val;
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
    };
  },
  methods: {
    init(v) {},
    handleSubmit() {
      this.cancelSubmit();
    },
    cancelSubmit: function () {
      this.dialogVisible = false;
      this.$emit("input", false);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped >
.userWx {
  &-content {
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    text-align: center;
    padding:10px 0;
  }
}
</style>

